import { RouteConfig, Route } from 'vue-router';
import Layout from '@/layout/index.vue';
import { ALL_ROLES } from '@/utils/permission';

const settingRoutes: RouteConfig = {
  path: '/setting',
  component: Layout,
  redirect: '/setting/password',
  meta: {
    title: 'Setting',
    icon: 'mdi-cog',
    alwaysShow: true,
  },
  children: [
    {
      path: 'supplier',
      component: () =>
        import(
          /* webpackChunkName: "setting" */ '@/views/setting/supplier/index.vue'
        ),
      name: 'setting-supplier',
      meta: {
        title: 'Setting supplier',
        icon: 'mdi-account-sync-outline',
      },
    },
    {
      path: 'password',
      component: () =>
        import(
          /* webpackChunkName: "setting" */ '@/views/setting/password/index.vue'
        ),
      name: 'setting-password',
      meta: {
        title: 'Setting password',
        icon: 'mdi-shield-lock-outline',
      },
    },
  ],
};

export default settingRoutes;
